'use strict';
define('videojsLoader',['global/window', 'global/document', 'videojs'], function (win, doc, videojs) {
	return videojs;
});

